
import React, { useRef, forwardRef, Ref, useImperativeHandle } from 'react'
import { useEffect } from 'react'


import { useTypedSelector } from '../../../../../../hooks/useTypeSelector';

import { FlyerPageDto } from '../../../../../../dtos'
import Canvas, { ICanvasRef } from '../../../../../../com/canvas/Canvas'

import Loader from '../../../../../../com/loader/Loader'

import { Spots } from '../../../../../com/canvas/spots/Spots'

import './FlyerPage.scss'
import { useState } from 'react'
import {ActionType} from "../../../../../../store/actionTypes";
import StatusPopup, {StatusPopupType} from "../../../../../../com/statusPopup/StatusPopup";
import {getSettingsForPopup} from "../../../../pages/getSetttingsForPopup";
import { getOriginalPageDimensions } from '../../../../../../globals';
import {getIconStyle} from "../../../../../../globals/globFunctions";

export interface IFlyerPageRef {
    // selectAllPageSpots(value: boolean): void;
    // deleteAllPageSpots(): void;
    setNextGridSize: (rows: number, columns: number) => void;
    reInit: () => void;
    showLoader: (value: boolean) => void;
}
export interface IFlyerPage {
    data?: FlyerPageDto,
}

export const FlyerPage = forwardRef((props: IFlyerPage, ref: Ref<IFlyerPageRef>) => {

    let flippingFlyerState = useTypedSelector((state) => state.flippingFlyer);
    const flyerDetailsState = useTypedSelector((state) => state.flyerDetails);
    const flyerIconStyleType = flyerDetailsState.flyGusRec?.gusIconContrast || 1;
    const iconStyleData = getIconStyle(flyerIconStyleType);

    useImperativeHandle(ref, () => ({ 
        reInit, 
        showLoader, 
        setNextGridSize, 
        // selectAllPageSpots, 
        // deleteAllPageSpots 
    }));

    const timer = useRef<NodeJS.Timeout | undefined>();
    const canvasRef = useRef<ICanvasRef>(null)

    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [isModalPopup, setModalPopup] = useState<boolean>(false);

    const canvasWidth = 530;
    const canvasHeigth = 679;

    const spots = useRef<Spots | null>(null)
	if (spots.current === null) {
		spots.current = new Spots(true, canvasWidth, canvasHeigth, false, true, iconStyleData)
	}

    // const selectAllPageSpots = (value: boolean) => {
    //     spots.current!.selectAllPageSpots(value);
    // }

    // const deleteAllPageSpots = () => {
    //     spots.current!.deleteAllPageSpots();
    // }

    const reInit = () => {
        dispose();

        // init
        spots.current = new Spots(true, canvasWidth, canvasHeigth, false, true, iconStyleData);
    }

    const dispose = () => {

        if(spots.current){
            spots.current!.dispose();
            if(spots.current!.parent) {
                spots.current!.parent.removeChild(spots.current!)
            }
            spots.current = null;
        }
        
        if (canvasRef.current) {
            canvasRef.current.reInitCanvas();
        }
    }

    const showLoader = (value: boolean) => {
        setIsLoading(value)
    }

    const setNextGridSize = (rows: number, columns: number) => {
        spots.current!.setNextGgridSize(rows, columns)
    }

    const onImageLoadComplete = (isComplete: boolean) => {
        showLoader(isComplete)
    }

    useEffect(() => {
        if (props.data !== null && canvasRef.current && props.data?.flyerPageSpots) {

            if (timer.current) {
                clearTimeout(timer.current)
            }

            timer.current = setTimeout(() => {
                setIsLoading(false)
            }, 2000);

            var originalDimensions = getOriginalPageDimensions(props.data)

            reInit();
            spots.current!.initSpotsDtos(props.data!, originalDimensions.originalWidth, originalDimensions.originalHeight, true, false)
            canvasRef.current?.addChild(spots.current!);
        }
        else {
            canvasRef.current?.addChild(spots.current!);
        }

        return () => {
            if (timer.current) {
                clearTimeout(timer.current)
            }
        };

    }, [props.data])

    useEffect(() => {
        // if (flippingFlyerState.loading === true) {
        setIsLoading(flippingFlyerState.loading);
        if(flippingFlyerState.type === ActionType.POST_FLYER_PROMOITEMS_SUCCESS){
            setModalPopup(true);
        }
        // }
    }, [flippingFlyerState.loading])

    useEffect(() => {

        return () => {
            // on unmount
            dispose();
        }
    }, []);

    const settings = {
        typeStatus: 0,
        title: '',
        subTitle: '',
        messages: ['Items uploaded successfully'],
        modalName: 'successfullyUpload',
    };


    let settingsForPopup = getSettingsForPopup(settings);


    return (
        <div className="flyer_page_container">
            <img src={props.data?.flpImageUrl} onLoad={() => {
                onImageLoadComplete(true)
            }} onError={() => {
                onImageLoadComplete(false)
            }} alt={""}/>

            <Canvas ref={canvasRef} id={'cavansTest'} width={canvasWidth} height={canvasHeigth} />

            {isLoading &&
                <div className="flyer_page_container_loader">
                    <Loader show={isLoading} />
                </div>
            }

            {isModalPopup && <StatusPopup
                settings={settingsForPopup}
                type={StatusPopupType.CONFIRM}
                title={'SUCCESS'}
                subTitle={''}
                messages={[settingsForPopup.messages]}
                show={isModalPopup}
                handleClose={() => setModalPopup(false)}
            />
            }
        </div>
    )
})
